// extracted by mini-css-extract-plugin
export default {"cover":"Cover_cover__j-zWj","cover__img":"Cover_cover__img__R7Jm5"};